import React from 'react';
import styled from 'styled-components';
import { OptimizedBreakpointSwitch } from '@peloton/responsive';
import { spaces } from '@engage/styles';
import { LibraryGrid } from '@members/library/Classes/LibraryGrid';
import { WidthContainer } from '@members/pg-library/shared';
import type { Props } from './Classes';
import { Loading } from './Loading';
import { useInsertUpsellCard } from './upsell-encouragement/helpers';

const FilterButtonSpacer = styled.div`
  display: block;
  height: 100%;
  margin: 0 auto;
  padding-bottom: ${spaces.huge}px;
  width: 100%;
`;

const ClassesView: React.FC<React.PropsWithChildren<Props>> = ({ ...props }) => {
  const classList = useInsertUpsellCard(props.classes);

  return (
    <WidthContainer ref={props.scrollBox}>
      <FilterButtonSpacer>
        <OptimizedBreakpointSwitch
          breakpoints={{
            mobile: (
              <LibraryGrid
                columns={1}
                classes={classList}
                onBookmarkClick={props.onBookmarkClick}
              />
            ),
            tabletLarge: (
              <LibraryGrid
                columns={2}
                classes={classList}
                onBookmarkClick={props.onBookmarkClick}
              />
            ),
            desktopXLarge: (
              <LibraryGrid
                columns={3}
                classes={classList}
                onBookmarkClick={props.onBookmarkClick}
              />
            ),
          }}
        />
        {/* To prevent pop-in, always show the spinner, unless there isn't anything to load */}
        <Loading isLoading={props.isLoading || props.hasPageAvailable} size={40} />
      </FilterButtonSpacer>
    </WidthContainer>
  );
};

export default ClassesView;
